import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCompositionAPI from '@vue/composition-api';
import InfiniteLoading from 'vue-infinite-loading';

import vuetify from './plugins/vuetify';
import './assets/scss/custom.scss';

// Import axios
import './plugins/axios';

// 3rd party plugins
Vue.use(VueCompositionAPI);
Vue.use(InfiniteLoading, {
  /* options */
});

Vue.config.productionTip = false;

Vue.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

// Create bus event
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
